"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrlOverrideConfig = void 0;
const web_env_1 = require("@snapchat/web-env");
function getUrlOverrideConfig(experimentId) {
    if (typeof window === "undefined") {
        return undefined;
    }
    const queryParams = new URLSearchParams(window.location.search);
    const queryParam = queryParams.get(`CONFIG:${experimentId}`);
    if (queryParam &&
        ((0, web_env_1.isRunningOnDevEnv)() ||
            (0, web_env_1.isSecproxyDomain)() ||
            (0, web_env_1.isRunningOnBSLocal)() ||
            (0, web_env_1.isRunningOnStaging)() ||
            (0, web_env_1.isRunningOnCloudfront)())) {
        return {
            configId: experimentId,
            value: {
                stringValue: String(queryParam),
                // Only used in internal usage, so dont need to handle parsing errors
                intValue: parseInt(queryParam),
            },
        };
    }
    return undefined;
}
exports.getUrlOverrideConfig = getUrlOverrideConfig;
//# sourceMappingURL=url-override.js.map